<ui-card
    *ngIf="integrationType"
    class="integration-card"
    [class.loading]="!connectionState"
    [class.hidden]="!imageLoaded"
    [withMargin]="false"
    [withSpacing]="false"
    [variant]="styleOptions.cardVariant ?? 'light'"
    role="group"
    [attr.aria-labelledby]="id + '-logo'"
    [attr.aria-describedby]="id + '-content'"
>
    @if (logoUrl) {
        <div class="logo" [id]="id + '-logo'">
            @if (shouldUseSVGLogo) {
                <app-svg-image [url]="logoUrl" [attr.aria-label]="integrationType.name" (onLoad)="imageLoaded = true" />
            } @else {
                <img [src]="logoUrl" [alt]="integrationType.name" (load)="imageLoaded = true" />
            }
        </div>
    }

    <ng-container *ngIf="connectionState">
        <ui-button
            *ngIf="(meatballMenuItems | keyvalue).length && !disabled"
            class="meatball"
            [matMenu]="meatball"
            size="mobile-shrink"
        >
            <mat-icon svgIcon="meatballVertical"></mat-icon>
        </ui-button>
        <div class="content" [id]="id + '-content'">
            <h5 class="description" role="group">
                <div><ng-content select=".description"></ng-content></div>
                {{ integrationTypeDescriptionTranslatable | translate }}
            </h5>
            @if (!disabled) {
                <ng-container *ngIf="connectionState === 'connected'">
                    <ui-badge type="success"
                        ><span class="only-large">{{ 'settings.integration-card.connectedLabel' | translate }}</span>
                        <mat-icon class="hide-large" svgIcon="success"
                    /></ui-badge>
                </ng-container>
                <ng-container *ngIf="connectionState === 'incomplete'">
                    <ui-badge type="danger"
                        ><span class="only-large">{{ 'settings.integration-card.incompleteLabel' | translate }}</span>
                        <mat-icon class="hide-large" svgIcon="warning" />
                    </ui-badge>
                </ng-container>
                <ng-container *ngIf="connectionState === 'errored'">
                    <ui-badge type="danger"
                        ><span class="only-large">{{ 'settings.integration-card.disconnectedLabel' | translate }}</span>
                        <mat-icon class="hide-large" svgIcon="cancel" />
                    </ui-badge>
                </ng-container>
                <ng-container *ngIf="connectionState === 'pendingApproval'">
                    <ui-badge type="warning"
                        ><span class="only-large">{{
                            'settings.integration-card.pendingApprovalLabel' | translate
                        }}</span>
                        <mat-icon class="hide-large" svgIcon="warning" />
                    </ui-badge>
                </ng-container>
            }
        </div>
    </ng-container>
    @if (disabled) {
        <ui-button [disabled]="true" type="primary" size="mobile-shrink">
            {{ 'settings.integration-card.connectButton' | translate }}
        </ui-button>
        <div class="integration-unavailable">{{ 'temporarilyUnavailable' | translate }}</div>
    } @else if (availableActions && primaryAction) {
        <ui-button
            (click)="onAction.emit(primaryAction.action)"
            [type]="primaryAction.buttonVariant ?? 'primary'"
            size="mobile-shrink"
        >
            {{ availableActions[primaryAction.action] | translate }}
        </ui-button>
    }
</ui-card>

<!-- Mat menu -->
<mat-menu #meatball>
    <button *ngFor="let action of meatballMenuItems | keyvalue" mat-menu-item (click)="onAction.emit(action.key)">
        {{ action.value | translate }}
    </button>
</mat-menu>
